
$(document).ready(function(){	
let bars = document.getElementById('bars');
let touch = $('#touchm');
let menu = $('.touch__nav');
$(touch).on('click', function(e) {
e.preventDefault();
menu.slideToggle();
bars.src.includes('/images/menu.png') ? bars.src = "/images/close.png" : bars.src = "/images/menu.png";
});
$(window).resize(function(){
let wid = $(window).width();
if(wid > 860 && menu.is(':hidden')) {
menu.removeAttr('style');
}
});
});

